import { c as _c } from "react/compiler-runtime";
import cx from 'classnames';
import { IconNames, Icon } from '@components/icon';
interface CarouselNavButtonProps {
  direction: 'prev' | 'next';
  disabled: boolean;
  onClick: () => void;
  title: string;
  className?: string;
}
export const CarouselNavButton: React.FC<CarouselNavButtonProps> = t0 => {
  const $ = _c(17);
  const {
    direction,
    disabled,
    onClick,
    title,
    className
  } = t0;
  const isPrev = direction === "prev";
  const iconName = isPrev ? IconNames.CHEVRON_LEFT : IconNames.CHEVRON_RIGHT;
  let t1;
  if ($[0] !== title) {
    t1 = title.toLowerCase();
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ariaLabel = `${isPrev ? "previous" : "next"} ${t1}`;
  const t2 = disabled ? "cursor-not-allowed bg-gray-xlight border-[1.5px] border-gray-light" : "bg-off-white border-[1.5px] border-gray-light hover:bg-pool hover:border-pool hover:shadow-md";
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = cx("focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-main inline-flex items-center justify-center w-10 h-10 rounded-full transition-all duration-200 shadow-sm", t2, className);
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = !disabled;
  let t5;
  if ($[5] !== disabled || $[6] !== t4) {
    t5 = cx("w-4 h-4 transition-colors duration-200", {
      "text-gray-light": disabled,
      "text-primary-main": t4
    });
    $[5] = disabled;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== iconName || $[9] !== t5) {
    t6 = <Icon name={iconName} className={t5} />;
    $[8] = iconName;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== ariaLabel || $[12] !== disabled || $[13] !== onClick || $[14] !== t3 || $[15] !== t6) {
    t7 = <button disabled={disabled} onClick={onClick} className={t3} type="button" aria-label={ariaLabel}>{t6}</button>;
    $[11] = ariaLabel;
    $[12] = disabled;
    $[13] = onClick;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};